import { id } from "date-fns/locale";

const BASE_URL = 'https://app-backend.fastcapital.pe/api';
const BASE_URL_CLIENT = 'https://app-backend.fastcapital.pe/api/gestion';
const BASE_URL_CREDITS = 'https://app-backend.fastcapital.pe/api/creditos';
const BASE_URL_CONTABILIDAD = 'https://app-backend.fastcapital.pe/api/contabilidad';

const CONFIGURACIONES = {
    INIT: {
        FLAG_CLOSE: 'CLOSE',
        ID_EDIT: 0,
        ID_ADD: -1,
        ARRAY: [],
        NUMBER: 0,
        NUMBER_DECIMAL: "0.00",
        TYPE_MENU: 'MENU',
        TYPE_SUB_MENU:'SUB_MENU',
        STATUS_RENDER_LIST: true,
        STATUS_TRUE: true,
        STATUS_FALSE: false,
        CURRENT_PAGE: 1,
        REQUIRED: 'Campo obligatorio',
        COLOR: '#FFF',
        TOAST_CLOSE: 2500,
        INTERVAL_SESSION: 10000,
        REDIRECT: 1000,
        SPINNER_DURATION: 2000,
        DURATION_MIN: 1000,
        STRING: '',
        ACCION_APROBAR: 'APROBAR',
        PATTERN: /.*/,
        HREF_LOGS: 'logs',
        NUMBER_COLUMNS_TABLE: 3,
        LIMIT_PAGE: 5,
        NULL: null,
        MAX_COLUMNS_TABLE: 7,
        TYPE_BQ_U: 'U', // Usuario
        TYPE_BQ_C: 'C', // Colaborador
        TYPE_BQ_S: 'S', // Solicitud
        TYPE_PERSON_NATURAL: 'NATURAL',
        TYPE_PERSON_JURIDICA: 'JURIDICA',
        TYPE_DOCUMENT_RUC: 3,
        TYPE_ADDRESS_CALLE_NUMERO: 'CALLE_NUMERO',
        TYPE_ADDRESS_MANZANA_LOTE: 'MANZANA_LOTE',
        TYPE_ZONE_CENTRO_POBLADO: 'CCPP',
        MAX_REFERENCIA_TIPO_DESEMBOLSO: 30,
        STRING_S: 'S',
        STRING_N: 'N',
        STRING_SI: 'SI',
        TIPOS_DESCUENTO: {
            INTERES: 'INTERES',
            COMISION: 'COMISION',
            MORA: 'MORA',
        },
        TIPOS_ACCION: {
            AMORTIZAR: 'AMORTIZAR',
            PAGAR: 'PAGAR'
        },
        TASA: {
            MIN: 0.01,
            MAX: 100.00,
        },
        TASA_MESSAGES: {
            MIN: 'La tasa debe ser mayor a 0. (Mínimo 0.01)',
            MAX: 'La tasa no puede ser mayor a 100',
        },
        ESTADOS_CUOTA: {
            ESTADO_EXTORNADO: 34,
            ESTADO_PAGADO: 29,
        },
        ESTADOS_DESCUENTO: {
            ESTADO_EXTORNADO: 33,
            ESTADO_VIGENTE: 32,
        },
        ESTADOS_DESEMBOLSO: {
            ESTADO_EXTORNO: 43
        },
        LIST_CATEGORIAS: {
            ACTIVO_FIJO: 'ACTIVO_FIJO',
            MERCADERIA: 'MERCADERIA',
            GASTOS_GENERALES: 'GASTOS_GENERALES',
            UNIDAD_FAMILIAR: 'UNIDAD_FAMILIAR',
            ENDEUDAMIENTO_EXTERNO: 'ENDEUDAMIENTO_EXTERNO',
            CLASIFICACION_DEUDOR: 'CLASIFICACION_DEUDOR',
            CLASIFICACION_SOLVENCIA_MORAL: 'CLASIFICACION_SOLVENCIA_MORAL',
            CLASIFICACION_CAPACIDAD_GESTION: 'CLASIFICACION_CAPACIDAD_GESTION'
        },
        LIST_TIPO_VIVIENDA: {
            PROPIA: 'PROPIA',
            ALQUILADA: 'ALQUILADA',
        },
        LIST_TIPO_ENDEUDAMIENTO: {
            INTERNO: 'INTERNO',
            EXTERNO: 'EXTERNO'
        },
        LIST_TIPO_DETALLE: {
            UNIDAD_FAMILIAR: 'UNIDAD_FAMILIAR',
            GESTION_NEGOCIO: 'GESTION_NEGOCIO'
        },
        LIST_APLICADO_A_METODOS_PAGO: {
            DESEMBOLSO_CREDITO: 'DESEMBOLSO_CREDITO',
            COBRO_CREDITO: 'COBRO_CREDITO',
            GENERAL: 'GENERAL'
        },
        LIST: {
            TIPOS_MOVIMIENTOS_CAJA: [
                { id: 'I', nombre: 'INGRESO'},
                { id: 'E', nombre: 'EGRESO'},
                { id: 'T', nombre: 'TRANSFERENCIA'},
            ],
            TIPOS_DOCUMENTO: [
                { id: 'B', nombre: 'BOLETA'},
                { id: 'F', nombre: 'FACTURA'},
                { id: 'BC', nombre: 'NOTA DE CREDITO - BOLETA'},
                { id: 'FC', nombre: 'NOTA DE CREDITO - FACTURA'},
                { id: 'BD', nombre: 'NOTA DE DEBITO - BOLETA'},
                { id: 'FD', nombre: 'NOTA DE DEBITO - FACTURA'},
            ],
            APLICADO_A_METODOS_PAGO: [
                { id: 'DESEMBOLSO_CREDITO', nombre: 'DESEMBOLSO DE CREDITOS'},
                { id: 'COBRO_CREDITO', nombre: 'COBRO DE CREDITOS'},
                { id: 'GENERAL', nombre: 'CAJA'}
            ],
            FORMAS_PAGO: [
                { id: 'EFECTIVO', nombre: 'EFECTIVO'},
                { id: 'TARJETA', nombre: 'TARJETA'},
                { id: 'DEPOSITO', nombre: 'DEPOSITO'},
                { id: 'TRANSFERENCIA', nombre: 'TRANSFERENCIA'},
                { id: 'BILLETERA DIGITAL', nombre: 'BILLETERA DIGITAL'},
            ],
            TIPOS_MOVIMIENTO_CAJA: [
                { id: 'I', nombre: 'INGRESO'},
                { id: 'E', nombre: 'EGRESO'},
                { id: 'T', nombre: 'TRANSFERENCIA'},
            ],
            TIPOS_CAJA: [
                { id: 'BOVEDA', nombre: 'BOVEDA'},
                { id: 'VENTANILLA', nombre: 'VENTANILLA'},
            ],
            NIVEL: [
                { id: 1, nombre: '1'},
                { id: 2, nombre: '2'},
            ],
            APLICADO_A_NIVEL_APROBACION: [
                { id: 'APROB_CREDITOS', nombre: 'APROBACIÓN DE CRÉDITO'},
                { id: 'APROB_TASA', nombre: 'APROBACIÓN DE TASA'},
            ],
            APLICADO_A_CATEGORIA_EVALUACION: [
                { id: 'ACTIVO_FIJO', nombre: 'ACTIVO FIJO'},
                { id: 'MERCADERIA', nombre: 'MERCADERIA'},
                { id: 'GASTOS_GENERALES', nombre: 'GASTOS GENERALES'},
                { id: 'UNIDAD_FAMILIAR', nombre: 'UNIDAD FAMILIAR'},
                { id: 'ENDEUDAMIENTO_EXTERNO', nombre: 'ENDEUDAMIENTO EXTERNO'},
                { id: 'CLASIFICACION_DEUDOR', nombre: 'CLASIFICACION DEL DEUDOR'},
                { id: 'CLASIFICACION_SOLVENCIA_MORAL', nombre: 'CLASIFICACION DE SOLVENCIA MORAL'},
                { id: 'CLASIFICACION_CAPACIDAD_GESTION', nombre: 'CLASIFICACION DE CAPACIDAD DE GESTION'},
            ],
            TIPO_DESCUENTOS: [
                { id: 'INTERES', nombre: 'Interés'},
                { id: 'COMISION', nombre: 'Comisión'},
                { id: 'MORA', nombre: 'Mora'},
            ],
            TIPO_ACCIONES: [
                { id: 'AMORTIZAR', nombre: 'Amortizar'},
                { id: 'PAGAR', nombre: 'Pagar'},
            ],
            TIPO_COMPONENTE: [
                { id: 'MENU', nombre: 'MENU'},
                { id: 'SUB_MENU', nombre: 'SUBMENU'},
            ],
            GENEROS: [
                { id: 'F', nombre: 'Femenino'},
                { id: 'M', nombre: 'Masculino'}
            ],
            TIPOS_BUSQUEDA: [
                { id: 'U', nombre: 'Usuario'},
                { id: 'C', nombre: 'Num. de Documento'},
            ],
            TIPOS_BUSQUEDA_TRANSACCIONES: [
                { id: 'S', nombre: 'Num. de Solicitud'},
                { id: 'C', nombre: 'Cliente'},
            ],
            TIPOS_CLIENTE: [
                { id: 'PERSONA', nombre: 'Persona'},
                { id: 'EMPRESA', nombre: 'Empresa'},
            ],
            ESTADOS_PROSPECCION: [
                { id: 'NUEVO', nombre: 'Nuevo'},
                { id: 'RECURRENTE', nombre: 'Recurrente'},
            ],
            ESTADOS_CIVIL: [
                { id: 'SOL', nombre: 'Soltero/a'},
                { id: 'CAS', nombre: 'Casado/a'},
                { id: 'VIU', nombre: 'Viudo/a'},
                { id: 'DIV', nombre: 'Divorciado/a'},
                { id: 'CON', nombre: 'Conviviente'},
                { id: 'SEP', nombre: 'Separado/a'},
            ],
            RELACION_INTERVENIENTES: [
                { id: 'AVAL', nombre: 'Aval'},
                { id: 'CONYUGE', nombre: 'Conyuge'},
                { id: 'CODEUDOR', nombre: 'Codeudor'},
                { id: 'REPRESENTANTE_LEGAL', nombre: 'Representante Legal'},
                { id: 'APODERADO', nombre: 'Apoderado'},
            ],
            FUENTES_DE_INGRESO: [
                { id: 'RECURSOS_PROPIOS', nombre: 'Recurso Propios'},
                { id: 'NEGOCIO', nombre: 'Negocio'},
            ],
            MONEDAS: [
                { id: 'SOLES', nombre: 'Soles'},
                { id: 'DOLARES', nombre: 'Dólares'},
            ],
            TIPOS_ZONA: [
                { id: 'URB', nombre: 'Urbanización'},
                { id: 'AAHH', nombre: 'Asentamiento Humano'},
                { id: 'PJ', nombre: 'Pueblo Joven'},
                { id: 'COOP', nombre: 'Cooperativa'},
                { id: 'CCPP', nombre: 'Centro Poblado'},
                { id: 'RES', nombre: 'Residencial'},
                { id: 'ZI', nombre: 'Zona Industrial'},
                { id: 'HU', nombre: 'Habilitacion Urbana'},
                { id: 'AA', nombre: 'Asociación'},
                { id: 'FND', nombre: 'Fundación'},
                { id: 'COM', nombre: 'Comunidad'},
                { id: 'GRU', nombre: 'Grupo Habitacional'},
            ],
            TIPOS_DIRECCION: [
                { id: 'CALLE_NUMERO', nombre: 'Calle y Número e Interior'},
                { id: 'MANZANA_LOTE', nombre: 'Manzana y Lote'}
            ],
            CATEGORIAS: [
                { id: 'RURAL', nombre: 'Rural'},
                { id: 'URBANO', nombre: 'Urbano'},
            ],
            ACCIONES: [
                { id: 'APROBAR', nombre: 'Aprobar'},
                { id: 'OBSERVAR', nombre: 'Observar'},
                { id: 'RECHAZAR', nombre: 'Rechazar'},
            ],
            ACCIONES_DESEMBOLSO: [
                { id: 'APROBAR', nombre: 'Aprobar'},
                { id: 'OBSERVAR', nombre: 'Observar'},
            ],
            TIPO_VIVIENDA: [
                { id: 'PROPIA', nombre: 'PROPIA'},
                { id: 'ALQUILADA', nombre: 'ALQUILADA'},
                { id: 'FAMILIAR', nombre: 'FAMILIAR'},
            ],
            DIAS_VENTA: [
                { id: 'DIAS_BUENOS', nombre: 'Días Buenos'},
                { id: 'DIAS_REGULARES', nombre: 'Días Regulares'},
                { id: 'DIAS_MALOS', nombre: 'Días Malos'},
            ],
            FACTORES_EVAL_CUANTITATIVA: [
                { id: '0.3', nombre: '0.3'},
                { id: '0.4', nombre: '0.4'},
                { id: '0.5', nombre: '0.5'},
                { id: '0.6', nombre: '0.6'},
            ],
            TIPOS_LOCAL: [
                { id: 'PROPIO', nombre: 'PROPIO'},
                { id: 'FAMILIAR', nombre: 'FAMILIAR'},
                { id: 'ALQUILADO', nombre: 'ALQUILADO'},
                { id: 'POSESION', nombre: 'POSESION'},
                { id: 'OTROS', nombre: 'OTROS'},
            ],
            TIPOS_MATERIAL_VIVIENDA: [
                { id: 'NOBLE', nombre: 'NOBLE'},
                { id: 'ADOBE', nombre: 'ADOBE'},
                { id: 'QUINCHA', nombre: 'QUINCHA'},
                { id: 'MADERA', nombre: 'MADERA'},
            ],
            ESCALAS_CALIFICACION: [
                { id: '1', nombre: 'Muy Mala'},
                { id: '2', nombre: 'Mala'},
                { id: '3', nombre: 'Aceptable'},
                { id: '4', nombre: 'Buena'},
                { id: '5', nombre: 'Muy Buena'},
            ]
        },
        ADDRESS: {
            calle: '',
            numero: '',
            interior: '',
            manzana: '',
            lote: '',
            referencia: '',
            telefono: '',
            tipoZona: '',
            nombreZona: '',
            tipoUbicacion: 'CALLE_NUMERO',
            centroPobladoSelect: '',
            centroPobladoId: '',
            centroPobladoNombre: '',
        },
        ALL_DAYS: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo']
    },
    MESSAGES: {
        TITLE: '¡Operación Exitosa!',
        TITLE_ERROR: '¡Operación Rechazada!',
        LIST_EMPTY: 'No se encontraron resultados en su Búsqueda.',
        SESSION_END: 'Sesión Terminada, Redirigiendo...',
        SUCCESS_OPERATION: 'Se ha registrado correctamente',
        SUCCESS_OPERATION_RATE: 'Se ha registrado solicitud de cambio de tasa correctamente',
        SUCCESS_USER: 'Se generó correctamente sus credenciales',
        SUCCESS_DELETE_OPERATION: 'Se ha eliminado correctamente',
        SUCCESS_EXTORN_OPERATION: 'Se ha extornado correctamente',
        SUCCESS_SEARCH_OPERATION: 'Se ha realizado búsqueda correctamente',
        SUCCESS_UPDATE_OPERATION: 'Se ha actualizado correctamente',
        DELETES: {
            ZONES: 'Estás a punto de eliminar la Zona: ',
            AGENCIES: 'Estás a punto de eliminar la Agencia: ',
            FILES: 'Estás a punto de eliminar el Archivo: ',
            COMPONENTS: 'Estás a punto de eliminar el Componente: ',
            AREAS: 'Estás a punto de eliminar el Área: ',
            CARGOS: 'Estás a punto de eliminar el Cargo: ',
            CENTROS_POBLADOS: 'Estás a punto de eliminar el Centro Poblado: ',
            NIVELES_DE_APROBACION: 'Estás a punto de eliminar el Nivel de Aprobación: ',
            CATEGORIAS_EVALUACION: 'Estás a punto de eliminar la Categoría de Evaluación: ',
            FUENTES_DE_INGRESO: 'Estás a punto de eliminar la Fuente de Ingreso: ',
            EMPLEADOS: 'Estás a punto de eliminar al Empleado: ',
            PRODUCTOS: 'Estás a punto de eliminar el Producto: ',
            TRANSACCIONES_PAGOS:'Estás a punto de Extornar el Pago:',
            TRANSACCIONES_DESCUENTO:'Estás a punto de Extornar el Descuento:',
            DOCUMENTOS_SERIE: 'Estás a punto de eliminar la Serie, con Tipo de Documento: ',
            CUENTAS_CONTABLE: 'Estás a punto de eliminar la Cuenta Contable: ',
            METODOS_PAGO: 'Estás a punto de eliminar el Método de Pago: ',
            CONCEPTOS_PAGO: 'Estás a punto de eliminar el Concepto de Pago: ',
            MOVIMIENTOS_CAJA: 'Estás a punto de eliminar el Movimiento de Caja: ',
            SOLICITUD_DESEMBOLSO:'Estás a punto de Extornar la Solicitud: ',
        }
    },
    URL: BASE_URL_CLIENT,
    ENDPOINTS: {
        ZONAS: `${BASE_URL_CLIENT}/zonas`,
        CENTROS_POBLADOS:  `${BASE_URL_CLIENT}/centros-poblado`,
        AGENCIAS: `${BASE_URL_CLIENT}/agencias`,
        COMPONENTES: `${BASE_URL_CLIENT}/componentes`,
        AREAS_EMPLEADO: `${BASE_URL_CLIENT}/areas-empleado`,
        CARGOS_EMPLEADO: `${BASE_URL_CLIENT}/cargos-empleado`,
        PERMISOS_COMPONENTE: `${BASE_URL_CLIENT}/componentes/permisos`,
        PERMISOS_AREAS_CARGOS: `${BASE_URL_CLIENT}/componentes/permisos-areas-cargos`,
        USUARIOS: `${BASE_URL_CLIENT}/usuarios`,
        CLIENTES: `${BASE_URL_CLIENT}/clientes`,
        METODOS_PAGO: `${BASE_URL_CLIENT}/metodos-pago`,
        PROSPECTOS: `${BASE_URL_CREDITS}/prospectos`,
        SOLICITUDES: `${BASE_URL_CREDITS}/solicitudes`,
        APROBACIONES: `${BASE_URL_CREDITS}/aprobacion`,
        TRANSACCIONES_CREDITO: `${BASE_URL_CREDITS}/transacciones-credito`,
        NIVELES_DE_APROBACION: `${BASE_URL_CREDITS}/niveles-aprobacion`,
        CATEGORIAS_EVALUACION: `${BASE_URL_CREDITS}/categorias-evaluacion`,
        PRODUCTOS: `${BASE_URL_CREDITS}/productos`,
        FUENTES_DE_INGRESO: `${BASE_URL_CREDITS}/fuentes-ingreso`,
        PUESTOS_TRABAJO: `${BASE_URL_CLIENT}/puestos-trabajo`,
        DEPARTAMENTOS:  `${BASE_URL_CLIENT}/departamentos`,
        EMPLEADOS: `${BASE_URL_CLIENT}/empleados`,
        ESTADOS: `${BASE_URL_CLIENT}/estados`,
        PAISES: `${BASE_URL_CLIENT}/util/paises`,
        LOGIN: `${BASE_URL_CLIENT}/login`,
        IDENTIFY_COMPANY: `${BASE_URL}/licencias/identificar`,
        DOCUMENTOS_SERIE: `${BASE_URL_CONTABILIDAD}/documentos-serie`,
        CUENTAS_CONTABLE: `${BASE_URL_CONTABILIDAD}/cuentas-contable`,
        CAJAS: `${BASE_URL_CONTABILIDAD}/caja`,
        MOVIMIENTOS_CAJA: `${BASE_URL_CONTABILIDAD}/movimientos-caja`,
        CONCEPTOS_PAGO: `${BASE_URL_CONTABILIDAD}/conceptos-pago`,
        UTILITARIOS: {
            EMPLEADOS_SELECT: `${BASE_URL_CLIENT}/util/empleados/show-data`,
            PAISES_SELECT: `${BASE_URL_CLIENT}/util/paises`
        }
    },
    REFS: {
        SELF: 'self',
        UPDATE: 'update',
        DELETE: 'delete'
    },
    ACTIONS: {
        MOSTRAR: 'MOSTRAR',
        CREAR: 'CREAR',
        ACTUALIZAR: 'ACTUALIZAR',
        ELIMINAR: 'ELIMINAR',
        RESETEAR: 'RESETEAR',
        APROBACION_CREDITOS: 'APROB_CRED'
    },
    TABLES:{
        HEADERS: {
            ZONES: [
                {label: 'NOMBRE', key: 'nombre'},
                {label: 'REGISTRADO POR', key: 'usuarioRegistro'},
                {label: 'ACTUALIZADO EL', key: 'fechaRegistro'},
            ],
            CENTROS_POBLADOS: [
                {label: 'NOMBRE', key: 'nombre'},
                {label: 'REGISTRADO POR', key: 'usuarioRegistro'},
                {label: 'ACTUALIZADO EL', key: 'fechaRegistro'},
            ],
            AGENCIES: [
                {label: 'NOMBRE', key: 'nombre'},
                {label: 'ZONA', key: 'zonaNombre'},
                {label: 'REGISTRADO POR', key: 'usuarioRegistro'},
                {label: 'ACTUALIZADO EL', key: 'fechaRegistro'},
            ],
            DOCUMENTS_SERIE: [
                {label: 'TIPO DE DOCUMENTO', key: 'tipoDocumentoNombre'},
                {label: 'SERIE', key: 'serie'},
                {label: 'CORRELATIVO', key: 'numero'},
                {label: 'DESCRIPCIÓN', key: 'descripcion'},
                {label: 'REGISTRADO POR', key: 'usuarioRegistro'},
                {label: 'ACTUALIZADO EL', key: 'fechaRegistro'},
            ],
            METODOS_PAGO: [
                {label: 'APLICADO A', key: 'aplicadoNombre'},
                {label: 'TIPO DE MOV. DE CAJA', key: 'tipoNombre'},
                {label: 'NOMBRE', key: 'nombre'},
                {label: 'ID INTERNO', key: 'idInterno'},
                {label: 'REGISTRADO POR', key: 'usuarioRegistro'},
                {label: 'ACTUALIZADO EL', key: 'fechaRegistro'},
            ],
            CONCEPTOS_PAGO: [
                {label: 'TIPO DE CAJA', key: 'tipoCaja'},
                {label: 'TIPO DE MOV. DE CAJA', key: 'tipoNombre'},
                {label: 'NOMBRE', key: 'nombre'},
                {label: 'REGISTRADO POR', key: 'usuarioRegistro'},
                {label: 'ACTUALIZADO EL', key: 'fechaRegistro'},
            ],
            CAJAS: [
                {label: 'NOMBRE', key: 'nombre'},
                {label: 'TIPO', key: 'tipoCajaNombre'},
                {label: 'SOLO EFECTIVO', key: 'soloEfectivo'},
                {label: 'SERIE ASIGNADA', key: 'serieAsignada'},
                {label: 'REGISTRADO POR', key: 'usuarioRegistro'},
                {label: 'ACTUALIZADO EL', key: 'fechaRegistro'},
            ],
            MOVIMIENTOS_CAJA: [
                {label: 'FECHA', key: 'fecha'},
                {label: 'TIPO', key: 'tipoNombre'},
                {label: 'CONCEPTO DE PAGO', key: 'conceptoPagoNombre'},
                {label: 'FORMA DE PAGO', key: 'metodoPagoNombre'},
                {label: 'MONTO', key: 'monto'},
                {label: 'MONEDA', key: 'moneda'},
                {label: 'ESTADO', key: 'estadoNombre'},
                {label: 'REGISTRADO POR', key: 'usuarioRegistro'},
                {label: 'ACTUALIZADO EL', key: 'fechaRegistro'},
            ],
            CUENTAS_CONTABLE: [
                {label: 'CÓDIGO', key: 'codigo'},
                {label: 'NOMBRE', key: 'nombre'},
                {label: 'REGISTRADO POR', key: 'usuarioRegistro'},
                {label: 'ACTUALIZADO EL', key: 'fechaRegistro'},
            ],
            COMPONENTS: [   
                {label: 'NOMBRE', key: 'nombre'},
                {label: 'ORDEN', key: 'orden'},
                {label: 'NIVEL', key: 'nivel'},
                {label: 'ENLACE INTERNO', key: 'enlaceInterno'},
                {label: 'COMPONENTE PADRE', key: 'componenteReferenciadoNombre'},
                {label: 'REGISTRADO POR', key: 'usuarioRegistro'},
                {label: 'ACTUALIZADO EL', key: 'fechaRegistro'},
            ],
            NIVELES_DE_APROBACION: [   
                {label: 'NIVEL DE APROBACIÓN', key: 'nivelAprobacionNombre'},
                {label: 'APLICADO A', key: 'aplicadoA'},
                {label: 'ORDEN', key: 'orden'},
                {label: 'REGISTRADO POR', key: 'usuarioRegistro'},
                {label: 'ACTUALIZADO EL', key: 'fechaRegistro'},
            ],
            CATEGORIAS_EVALUACION: [
                {label: 'NOMBRE', key: 'nombre'},
                {label: 'APLICADO A', key: 'aplicadoA'},
                {label: 'REGISTRADO POR', key: 'usuarioRegistro'},
                {label: 'ACTUALIZADO EL', key: 'fechaRegistro'},
            ],
            PRODUCTOS: [   
                {label: 'NOMBRE', key: 'nombre'},
                {label: 'TIPO DE CRÉDITO', key: 'tipoCreditoNombre'},
                {label: 'TASA MIN. (%)', key: 'tasaMinInteres'},
                {label: 'TASA MAX. (%)', key: 'tasaMaxInteres'},
                {label: 'REGISTRADO POR', key: 'usuarioRegistro'},
                {label: 'ACTUALIZADO EL', key: 'fechaRegistro'},
            ],
            FUENTES_DE_INGRESO: [   
                {label: 'NOMBRE', key: 'nombre'},
                {label: 'TIPO DE FUENTE DE INGRESO', key: 'tipoFuenteIngreso'},
                {label: 'REGISTRADO POR', key: 'usuarioRegistro'},
                {label: 'ACTUALIZADO EL', key: 'fechaRegistro'},
            ],
            AREAS: [
                {label: 'NOMBRE', key: 'nombre'},
                {label: 'DESCRIPCIÓN', key: 'descripcion'},
                {label: 'REGISTRADO POR', key: 'usuarioRegistro'},
                {label: 'ACTUALIZADO EL', key: 'fechaRegistro'},
            ],
            CARGOS: [
                {label: 'NOMBRE', key: 'nombre'},
                {label: 'DESCRIPCIÓN', key: 'descripcion'},
                {label: 'REGISTRADO POR', key: 'usuarioRegistro'},
                {label: 'ACTUALIZADO EL', key: 'fechaRegistro'},
            ],
            EMPLOYEES: [
                {label: 'T. DOCUMENTO', key: 'tipoDocumentoNombre'},
                {label: 'N° DOCUMENTO', key: 'numeroDocumento'},
                // {label: 'APELLIDO PATERNO', key: 'apellidoPaterno'},
                // {label: 'APELLIDO MATERNO', key: 'apellidoMaterno'},
                {label: 'APELLIDOS Y NOMBRES', key: 'nombreCompleto'},
                {label: 'CELULAR', key: 'celular'},
                {label: 'EMAIL', key: 'correoElectronico'},
                {label: 'FECHA DE NACIMIENTO', key: 'fechaNacimiento'},
                {label: 'GÉNERO', key: 'genero'},
                {label: 'ÁREA', key: 'areaEmpleadoNombre'},
                {label: 'CARGO', key: 'cargoEmpleadoNombre'},
                {label: 'TIPO DE EMPLEADO', key: 'tipoEmpleadoNombre'},
                {label: 'FECHA DE INGRESO', key: 'fechaIngreso'},
                {label: 'REGISTRADO POR', key: 'usuarioRegistro'},
                {label: 'ACTUALIZADO EL', key: 'fechaRegistro'},
            ],
        },
        PAGES: [5, 10, 20, 50, 100, 500]
    },
    SITES: {
        ZONES: `/view/zones`,
        AGENCIES: `/view/agencies`,
        EMPLOYEES: `/view/employees`,
        COMPONENTS: `/view/components`,
        NIVEL_DE_APROB: `/view/niveles-de-aprobacion`,
        CATEGORIAS_EVALUACION: `/view/categorias-evaluacion`,
        FUENTES_DE_INGRESO: `/view/fuentes-de-ingreso`,
        AREAS: `/view/areas`,
        CARGOS: `/view/cargos`,
        PRODUCTOS: `/view/productos`,
        EVALUATION: `/view/evaluation`,
        CENTROS_POBLADOS: `/view/centro-poblado`,
        EVALUATION_STEP_02: `/view/evaluation/step-02`,
        DOCUMENTS_SERIE: `/view/document-series`,
        CAJAS: `/view/boxs`,
        CUENTAS_CONTABLES: `/view/cuentas-contables`,
        METODOS_PAGO: `/view/metodos-pago`,
        CONCEPTOS_PAGO: `/view/conceptos-pago`,
    },
    RESPONSES: {
        SUCCESS: 'success',
        ERROR: 'error'
    },
    RESPONSES_HTTP: {
        CODE_201: '201',
        CODE_2O4: '204',
        CODE_200: '200',
        CODE_4O0: '400'
    },
    STATUS: {
        ACTIVE: 'A',
        INACTIVE: 'I',
    },
    TABS: {
        LIST: 'Listado',
        NEW: 'Nuevo',
        EDIT: 'Editar',
    },
    INDEX_TABS: {
        LIST: 0,
        FORM: 1
    },
    POSITION: {
        BOTTOM_RIGHT: 'bottom-right',
        BOTTOM_CENTER: 'bottom-center',
    },
    HEADER_TYPE: 'application/json',
    TOKEN_SECRET: 'AdminFastCapital2025#$ñ*Ñ',
    INIT_REDIRECT_PAGE: '/view/home',
};

export default CONFIGURACIONES;